// visits/VisitsEmptyState.jsx
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";

export default function VisitsEmptyState({ title, subtitle }) {
  return (
    <div className="hc-cd-empty">
      <div className="hc-cd-empty__icon">
        <FontAwesomeIcon icon={faClockRotateLeft} />
      </div>
      <div className="hc-cd-empty__title">{title}</div>
      <div className="hc-cd-empty__subtitle">{subtitle}</div>
    </div>
  );
}
